export default {
	// Page headings
	er_cover_default_title: 'Performance Review',
	er_page_success_metrics: 'What changed this month',
	er_page_success_metrics_range: 'What changed in this period',
	er_page_success_metrics_week: 'What changed this week',
	er_page_comparison: 'Comparison Summary',
	er_page_period_summary: 'Month summary',
	er_page_period_summary_range: 'Period summary',
	er_page_period_summary_week: 'Week summary',
	er_page_each_month: 'Each month',
	er_page_rooms: 'Rooms',
	er_rooms_note: 'Every room in {month}, best score first.',
	er_page_shift_comparison: 'Shift comparison',
	er_page_shift_summary: 'By shift',
	er_page_response_time: 'Average Response Time (mins)',
	er_page_avg_score: 'Experience Score',
	er_page_complaints_vs_visits: 'Complaints vs Visits',
	er_page_performance_trends: 'Performance Trends',
	er_page_complaint_drivers: 'Complaint Drivers',

	// Findings board
	er_board_working: 'Improved vs {month}',
	er_board_attention: 'Needs attention vs {month}',
	er_board_empty: 'No notable changes this month.',
	er_board_empty_range: 'No notable changes in this period.',
	er_board_empty_week: 'No notable changes this week.',
	er_findings_intro: 'Compared with {month}. Only notable changes are shown.',
	er_verdict_improved: 'Improved',
	er_verdict_watch: 'Needs attention',

	// Comparison table
	er_col_metric: 'Metric',
	er_col_avg: 'YTD Avg',
	er_col_lifetime_avg: 'Since start Avg',
	er_comparison_note: 'YTD Avg is the year-to-date figure from January through {month}.',
	er_lifetime_note: 'Since start Avg is the monthly average from the first day with data through {month}.',
	er_comparison_note_week: 'The report week is compared with the selected previous week.',
	er_period_only_note: 'Figures are for {month} only.',
	er_each_month_note: 'Each month in the selected period. A month with no data is left blank.',
	er_col_inc_dec: 'Inc / Dec',
	er_col_complaint: 'Complaint',
	er_col_qty: 'Qty',
	er_total: 'Total',

	// Comparison metric names
	er_metric_avg_score: 'Experience Score',
	er_metric_avg_response_time: 'Avg Response Time',
	er_metric_cleaner_arrivals: 'Cleaner Arrivals',
	er_metric_supervisor_inspections: 'Supervisor Inspections',
	er_metric_complaints_vs_visits_pct: 'Complaints vs. Visits (%)',
	er_metric_complaints: 'Complaints',
	er_metric_customer_visits: 'Visits',
	er_metric_expired_slas: 'Expired SLAs',
	// Stat cards
	er_unit_min: 'min',
	er_stat_expected_sla: 'Expected SLA',
	er_stat_vs_minutes: 'vs {value} in {month}',
	er_stat_vs_count: 'vs {value} in {month}',
	er_label_complaints: 'Complaints',
	er_label_visits: 'Visits',
	er_label_complaints_per_visits: 'Complaints / visits',
	er_chart_ratio: 'Complaints-to-visits ratio',
	er_chart_ytd_window: 'January through {month}.',
	er_cv_formula:
		'Complaints divided by restroom visits, as a percentage: ({complaints} ÷ {visits}) × 100 = {ratio}% in {month}.',
	er_export_kpis_title: 'What\'s included',
	er_export_kpis_desc: 'All of these are in the report. Turn one off to leave it out.',
	er_export_select_all: 'Select all',
	er_export_clear_all: 'Clear all',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Report period',
	er_export_grain: 'Report by',
	er_export_grain_month: 'Month',
	er_export_grain_week: 'Week',
	er_export_week_starts: 'Week starts on',
	er_export_week_starts_sunday: 'Sunday',
	er_export_week_starts_monday: 'Monday',
	er_export_report_month: 'Report month',
	er_export_from_month: 'From',
	er_export_to_month: 'To',
	er_export_period_note_range: 'Totals cover every month from the start through the end. When comparison is on, it uses the previous stretch of the same length. Year-to-date figures still run from January through the end month.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'The previous period of the same length.',
	er_export_report_week: 'Report week',
	er_export_compare_month: 'Compare with',
	er_export_shift: 'Shift',
	er_export_shift_all: 'All shifts',
	er_export_no_shifts: 'This site has no active shifts.',
	er_export_render_failed: 'The report could not be drawn correctly, so it was not downloaded. Refresh the page and try again.',
	er_export_comparison: 'Comparison',
	er_export_include_previous: 'Include the previous period',
	er_export_comparison_on: 'On',
	er_export_comparison_off: 'Off',
	er_export_no_previous_data: 'There is no data before this period, so there is nothing to compare with.',
	er_export_compare_previous: 'Previous month',
	er_export_compare_previous_week: 'Previous week',
	er_export_compare_last_year: 'Same month last year',
	er_export_no_periods: 'This site needs at least one month of data before a report can be exported.',
	er_export_no_periods_week: 'This site needs at least one week of data before a report can be exported.',
	er_export_period_note: 'Only months with data are listed. Year-to-date figures always run from January through the report month.',
	er_export_period_note_week: 'Only weeks with data are listed. Comparison is always against an earlier week.',
	er_export_period_note_single_week: 'Only weeks with data are listed.',

	// Findings
	er_find_response_time_title: 'Average Response Time',
	er_find_response_time_change: 'Changed from {previous} to {current} minutes ({change}).',
	er_find_avg_score_title: 'Experience Score',
	er_find_score_eased: 'Dropped from {previous} to {current}.',
	er_find_score_improved: 'Rose from {previous} to {current}.',
	er_find_score_ytd_inline: 'Matches the year-to-date average of {ytd}.',
	er_find_score_ytd_inline_range: 'Matches the average from January through {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Year-to-date average: {ytd}.',
	er_find_score_ytd_against_range: 'Average from January through {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Complaints to Visit Ratio',
	er_find_complaints_ratio_improved: 'Improved from {previous} to {current}.',
	er_find_complaints_ratio_rose: 'Changed from {previous} to {current}.',

	// Page narratives
	er_nar_cv_year_improved:
		'Customer complaints relative to restroom visits improved from {from} to {to} across the year.',
	er_nar_cv_year_rose: 'Customer complaints relative to restroom visits rose from {from} to {to} across the year.',
	er_nar_cv_moved: 'Customer complaints relative to restroom visits moved from {previous} to {current}.',
	er_nar_cv_current: 'Customer complaints relative to restroom visits are at {current}.',
	er_nar_types_total: 'Total complaints {total}.',
	er_nar_types_1: 'Top complaint: {a} ({ap}%).',
	er_nar_types_2: 'Top complaint: {a} ({ap}%) followed by {b} ({bp}%).',
	er_nar_types_3: 'Top complaint: {a} ({ap}%) followed by {b} ({bp}%) and {c} ({cp}%).',
	er_find_rooms_slowest: 'Rooms with the longest response time this month: {rooms}.',
	er_find_rooms_slowest_range: 'Rooms with the longest response time in this period: {rooms}.',
	er_find_rooms_slowest_week: 'Rooms with the longest response time this week: {rooms}.',
	er_find_rooms_lowest_score: 'Lowest-scoring rooms this month: {rooms}.',
	er_find_rooms_lowest_score_range: 'Lowest-scoring rooms in this period: {rooms}.',
	er_find_rooms_lowest_score_week: 'Lowest-scoring rooms this week: {rooms}.',
	er_find_so_what_ratio: 'Most of the change came from {rooms}.',
	er_find_so_what_type: 'Top complaint: {name} ({percent}%).',
	er_hot_slowest: 'Rooms with the longest response time',
	er_hot_expired_slas: 'Rooms that exceeded the SLA',
	er_hot_ratio: 'Rooms with the biggest change in complaint rate',
	er_hot_top_type: 'Rooms with the most "{name}" complaints',
	er_hot_col_room: 'Room',
	er_col_response: 'Response',
	er_col_cleaners: 'Cleaners',
	er_col_score: 'Score',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Ratio',
	er_hot_col_change: 'Change',
	er_hot_col_count: 'Qty',
	er_hot_empty: 'No room-level highlights this month.',
	er_hot_empty_range: 'No room-level highlights in this period.',
	er_hot_empty_week: 'No room-level highlights this week.',
	er_cover_highlights: 'This month',
	er_cover_highlights_range: 'This period',
	er_cover_highlights_week: 'This week',
	er_cover_score_rose: 'Experience Score rose.',
	er_cover_score_eased: 'Experience Score eased.',
	er_cover_response_improved: 'Response time improved.',
	er_cover_response_slowed: 'Response time slowed.',
	er_cover_ratio_fell: 'Complaints vs visits fell.',
	er_cover_ratio_rose: 'Complaints vs visits rose.',
	er_export_pdf: 'Dashboard PDF',
	er_export_executive: 'Executive report',
	'executive-report': 'Executive report',
	er_export_csv: 'CSV',
	er_export_status_title: 'Creating your report',
	er_export_status_fetch: 'Loading the numbers',
	er_export_status_layout: 'Laying out the pages',
	er_export_status_page: 'Page {page} of {total}',
	er_footer_copyright: 'This report was generated via the BuzzzTech system.',
	er_contact_line: 'Questions or want to explore the data further? Contact your BuzzzTech Customer Success team at {email} or {phone}.',
};
